import { useState } from 'react';
import { Button } from '../components/Button.jsx';
import { Card } from '../components/Card.jsx';
import { useFocusOnMount } from '../components/useFocusOnMount.js';
import { startGame } from '../state/actions.js';
import { GAME_YEARS } from '../data/constants.js';

function pickRandomSeed() {
  return ((Math.random() * 0xffffffff) >>> 0) || 1;
}

export function TitleScreen({ dispatch, onShowRules }) {
  const mainRef = useFocusOnMount();
  const [advanced, setAdvanced] = useState(false);
  const [seedInput, setSeedInput] = useState('');

  function handleStart() {
    let seed;
    if (advanced && seedInput.trim() !== '') {
      const parsed = Number.parseInt(seedInput, 10);
      seed = Number.isFinite(parsed) && parsed > 0 ? parsed >>> 0 : pickRandomSeed();
    } else {
      seed = pickRandomSeed();
    }
    dispatch(startGame(seed));
  }

  return (
    <main ref={mainRef} id="main" tabIndex={-1} className="screen screen-title">
      <Card title="Plan a national power system" titleId="title-heading">
        <p className="card-body">
          You are the energy planner. Across {GAME_YEARS} in-game years
          you will build a portfolio of power plants to meet rising
          electricity demand. Your final score is the total cost: capital
          plus operating, plus shortfall penalties, plus carbon tax (or
          minus a carbon bonus). The lowest cost wins.
        </p>
        <p className="card-body">
          Fossil plants look cheap until the carbon tax lands. Variable
          renewables carry real shortfall risk. Monoculture is punished
          when one disruption hits your whole portfolio.
          Diversification across technology families is the safe bet.
        </p>

        <div className="title-controls">
          <Button onClick={handleStart} changesScreen testId="title-start">
            New game
          </Button>
          <Button variant="ghost" onClick={onShowRules} changesScreen testId="title-rules">
            How to play
          </Button>
        </div>

        <details
          className="title-advanced"
          open={advanced}
          onToggle={(e) => setAdvanced(e.currentTarget.open)}
        >
          <summary>Advanced</summary>
          <label className="title-seed-label" htmlFor="title-seed-input">
            Seed (positive integer, optional)
          </label>
          <input
            id="title-seed-input"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={seedInput}
            onChange={(e) => setSeedInput(e.target.value)}
            className="title-seed-input"
            placeholder="Random"
            data-testid="title-seed-input"
          />
          <p className="title-seed-help">
            Use the same seed to replay an identical sequence of
            disruptions and output outcomes.
          </p>
        </details>
      </Card>
    </main>
  );
}
